export default "__VITE_ASSET__b9396b30__"